import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = {
  key: 0,
  class: "icon-wrapper"
}
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_5 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_6 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_7 = {
  class: "dialog-body",
  ref: "body"
}
const _hoisted_8 = {
  key: 0,
  class: "dialog-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "dialog-fade" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dialog-overlay",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBackdropClick && _ctx.handleBackdropClick(...args)), ["self"]))
            }, [
              _createVNode(_Transition, { name: "dialog-scale" }, {
                default: _withCtx(() => [
                  (_ctx.show)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["dialog-container", [`dialog-${_ctx.type}`, { 'dialog-large': _ctx.large }]])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["dialog-header", `header-${_ctx.type}`])
                        }, [
                          _createElementVNode("div", _hoisted_1, [
                            (_ctx.showIcon)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  (_ctx.type === 'error')
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[3] || (_cache[3] = [
                                        _createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }, null, -1)
                                      ]))]))
                                    : (_ctx.type === 'warning')
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[4] || (_cache[4] = [
                                          _createElementVNode("path", { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" }, null, -1)
                                        ]))]))
                                      : (_ctx.type === 'success')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[5] || (_cache[5] = [
                                            _createElementVNode("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" }, null, -1)
                                          ]))]))
                                        : (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[6] || (_cache[6] = [
                                            _createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }, null, -1)
                                          ]))]))
                                ]))
                              : _createCommentVNode("", true),
                            _renderSlot(_ctx.$slots, "header", {}, () => [
                              _createVNode(_Transition, {
                                name: "title-fade",
                                mode: "out-in"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock("h2", {
                                    key: _ctx.title,
                                    class: "dialog-title"
                                  }, _toDisplayString(_ctx.title), 1))
                                ]),
                                _: 1
                              })
                            ], true)
                          ]),
                          (!_ctx.fixed)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "close-button",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                                "aria-label": "Close dialog"
                              }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 24 24",
                                  fill: "currentColor"
                                }, [
                                  _createElementVNode("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: "dialog-body-wrapper",
                          ref: "bodyWrapper",
                          style: _normalizeStyle(_ctx.bodyHeight ? { height: _ctx.bodyHeight + 'px' } : {})
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_Transition, {
                              name: "content-fade",
                              mode: "out-in",
                              onEnter: _ctx.onContentEnter,
                              onLeave: _ctx.onContentLeave
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock("div", {
                                  key: `content-${_ctx.title}`,
                                  class: "dialog-content-wrapper",
                                  ref: "content"
                                }, [
                                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                                ]))
                              ]),
                              _: 3
                            }, 8, ["onEnter", "onLeave"])
                          ], 512)
                        ], 4),
                        _createVNode(_Transition, { name: "footer-fade" }, {
                          default: _withCtx(() => [
                            (!_ctx.fixed && _ctx.showActions)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _renderSlot(_ctx.$slots, "actions", {}, () => [
                                    _createElementVNode("button", {
                                      class: "dialog-button dialog-button-primary",
                                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
                                    }, _toDisplayString(_ctx.confirmText), 1)
                                  ], true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 3
                        })
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}